import { render, staticRenderFns } from "./PrepAreas.vue?vue&type=template&id=a3341eea"
import script from "./PrepAreas.vue?vue&type=script&lang=js"
export * from "./PrepAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports